import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div data-slot="empty-state" className={cn("grid justify-items-center gap-3 px-6 py-10 text-center", className)}>
      {icon ? <div className="text-muted">{icon}</div> : null}
      <div className="grid gap-1">
        <h3 className="font-display text-xl tracking-[-0.03em]">{title}</h3>
        {description ? <div className="max-w-sm text-sm text-secondary">{description}</div> : null}
      </div>
      {action}
    </div>
  );
}
